import axiosInstance from "../axios.service"
import BaseUrl from "../url.service"

const serverUrl = `${BaseUrl}/webPrivacy`

export const getPrivacyApi = () => {
    return axiosInstance.get(`${serverUrl}/get`)
}

export const addOrUpdatePrivacyApi = (formData) => {
    return axiosInstance.post(`${serverUrl}/create-update`, formData)
}

export const deletePrivacyApi = (id) => {
    return axiosInstance.delete(`${serverUrl}/${id}`)
}

const privacyService = {
    getPrivacy: getPrivacyApi,
    savePrivacyApi: addOrUpdatePrivacyApi,
    deletePrivacyApi
}

export default privacyService
